module.exports = __webpack_public_path__ + "assets/img/about-content-icon2.9a3262d4.svg";